import React from 'react'
import {IconBank, ListItem} from '@Knowledge-OTP/znk-ui-components'

const DebitPaymentMethod = (props) => {
  const {last4, bankName, isClickable, isParent} = props
  return (
    <>
      <ListItem
        className='px-4'
        showTopLine={!isParent}
        showBottomLine={!isParent}
        hasColorHover={isClickable}
        hasHover={isClickable}
        Left={
          <span className='d-flex align-items-center text-gray'>
            <IconBank className='mr-2' />
            ACH Debit
          </span>
        }
        Right={<span className='mr-2 font-weight-light text-gray'>{`${last4} ${bankName}`}</span>}
      />
    </>
  )
}

export default DebitPaymentMethod
